export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5309.37033881.jpg";